import { Button, Col, Row, Space, Switch, Typography } from "antd";
import { ColumnsType } from "antd/es/table";
import { Table } from "antd";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { ExamGroup, ExamPeriod, ExamPeriodState } from "@types";
import { useState } from "react";
import dayjs from "dayjs";
import { useEditExamPeriod, useGetExamGroups } from "@hooks";
import { useNavigate } from "react-router-dom";
import { getKeycloakRealm } from "@/components/helpers";

interface Props {
  examPeriod?: ExamPeriod;
}

export const ExamPeriodPublish = ({ examPeriod }: Props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const editExamPeriod = useEditExamPeriod();
  const { data, isLoading } = useGetExamGroups(examPeriod?.id, true);
  const [checked, setChecked] = useState(
    examPeriod?.state == ExamPeriodState.Active || 
    examPeriod?.state == ExamPeriodState.Completed ||
    examPeriod?.state == ExamPeriodState.InProgress
  );

  const periodPublish: ColumnsType<ExamGroup> = [
    {
      title: t("table.groupName"),
      dataIndex: "name",
      key: "name",
    },
    {
      title: t("table.numQ"),
      dataIndex: "numberOfQuestionsInGroup",
      key: "count",
    },
  ];

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 1 }}
    >
      <div style={{ display: "flex", justifyContent: "center" }}>
        <div style={{ maxWidth: 500 }}>
          <Space direction="vertical">
            <Space>
              <Typography.Text strong>
                {t("pages.examPeriods.publishTab.dateOfExam")}:
              </Typography.Text>
              <Typography.Text>
                {dayjs(examPeriod?.date).format("D.MM.YYYY H:mm")}
              </Typography.Text>
            </Space>
            <Space align="start">
              <Typography.Text strong>
                {t("pages.examPeriods.publishTab.groupsAndQ")}:
              </Typography.Text>
              <Table
                dataSource={data}
                rowKey={(record) => record.id}
                loading={isLoading}
                columns={periodPublish}
                size="small"
              />
            </Space>
            <Space>
              <Typography.Text strong>
                {t("pages.examPeriods.publishTab.numberOfApplicants")}:
              </Typography.Text>
              <Typography.Text>
                {examPeriod?.userExaminees.length}
              </Typography.Text>
            </Space>
            <Space direction="vertical">
              <Typography.Text strong>
                {t("pages.examPeriods.publishTab.activateExam")}
              </Typography.Text>
              <Switch disabled={examPeriod?.state !== ExamPeriodState.InActive} checked={checked} onChange={(val) => setChecked(val)} />
            </Space>
          </Space>
        </div>
      </div>
      <Row>
        <Col
          span={24}
          style={{
            display: "flex",
            flexDirection: "row-reverse",
          }}
        >
          <Space>
            <Button onClick={() => navigate(-1)}>{t("pages.examsManagment.cancel")}</Button>
            <Button
              type="primary"
              htmlType="submit"
              disabled={ examPeriod !== undefined ? examPeriod?.state !== ExamPeriodState.InActive : false }
              loading={editExamPeriod.isPending}
              onClick={() => {
                editExamPeriod.mutate(
                  { ...examPeriod, id: examPeriod?.id, state: checked ? ExamPeriodState.Active : ExamPeriodState.InActive },
                  {
                    onSuccess() {
                      navigate(`/${getKeycloakRealm}/exam-periods`);
                    },
                  }
                );
              }}
            >
              {t("pages.examsManagment.saveQuit")}
            </Button>
          </Space>
        </Col>
      </Row>
    </motion.div>
  );
};
